"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBillingHeading = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledBillingHeading = styled_components_1.default.div(function (_a) {
    var mediaQueries = _a.theme.mediaQueries;
    return "\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  flex-direction: column;\n  min-height: 12rem;\n\n  ".concat(mediaQueries.smallAndUp, " {\n    flex-direction: row;\n    min-height: auto;\n    align-items: center;\n  }\n");
});
